import styled from '@emotion/styled';
import { ContentWrapper } from '../../../styles/layout';

export const Wrapper = styled.div`
  ${ContentWrapper}
`;
